import { _API, _AXIOS_HELPER, _HEADER } from '@/static';
import * as ENUM from "@/enum/lib";

export default {
    // getExerciseRecordBySeqExerciseAndSeqMedicalRelation(seqExercise) {
    //     return new Promise((resolve, reject) => {
    //         const url = _API + '/exercise/getAssignedExerciseRecordBySeqExercise';
    //         const conf = {
    //             headers: _HEADER()
    //         };
    //
    //         const data = {seqExercise};
    //
    //         _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
    //             .then(res => {
    //                 resolve(res);
    //             })
    //             .catch(err => {
    //                 reject(err);
    //             });
    //     });
    // },
    getAllMyPatientExerciseHistoryByLimit(seqManager, currentPage, size, orderByData, device = 1) {
        return new Promise((resolve, reject) => {
            const url = _API + `/exercise/getAllMyPatientExerciseHistoryByLimit/${device === 1 ? 'v2' : 'pro'}`
            const conf = {
                headers: _HEADER()
            };

            const data = {
                seqManager,
                startIndex: currentPage,
                size,
                sortingParam: orderByData.columnKey,
                isDesc: orderByData.desc ? 0 : 1
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, {
                "page": data.startIndex,
                "size": data.size,
                sortingParam: data.sortingParam,
                isDesc: data.isDesc
            }, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    getAllBySearchWordAndSeqMedicalRelation(page, size, seqMedicalRelation, orderByData, device = 1) {
        return new Promise((resolve, reject) => {
            const home  = '/exercise/rehabilitationMode/getAllBySearchWordAndSeqMedicalRelation';
            const pro   = '/exercise/rehabilitationMode/getBySearchWordAndSeqMrForReblessPro';
            const url = _API + (device === 1 ? home : pro);
            const conf = {
                headers: _HEADER()
            };

            const data = {
                page,
                size,
                seqMedicalRelation,
                sortingParam: orderByData.columnKey,
                isDesc: orderByData.desc ? 0 : 1
            };

            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    getAllExerciseHistoryBySeqMedicalRelationByLimit(data, orderByData) {
        return new Promise((resolve, reject) => {
            const url = _API + '/exercise/getAllExerciseHistoryBySeqMedicalRelationByLimit/v2';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, {
                "seqMedicalRelation": data.seqMedicalRelation,
                "page": data.startIndex,
                "size": data.size,
                sortingParam: orderByData.columnKey,
                isDesc: orderByData.desc ? 0 : 1
            }, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    addExercise(data) {
        data.exerciseGuideEvent = 'RomExercise';
        return new Promise((resolve, reject) => {
            const url = _API + '/exercise/addClinicAssignedExercise';
            const conf = {
                headers: _HEADER()
            };

            let exerciseGuideTime = data?.exerciseGuide?.exerciseGuideTime;
            let date = new Date(null);
            date.setSeconds(exerciseGuideTime);
            let result = date.toISOString().substr(11, 8);

            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, {
                ...data,
                exerciseGuide: {
                    ...data.exerciseGuide,
                    exerciseGuideTime: result,
                }
            }, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    updateExerciseStatusBySeqExercise(data) {
        return new Promise((resolve, reject) => {
            const url = _API + "/exercise/updateExerciseStatusBySeqExercise";
            const conf = {
                headers: _HEADER()
            };

            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    deleteExerciseGuideBySeqExercise(seqExercise) {
        const data = {seqExercise};
        return new Promise((resolve, reject) => {
            const url = _API + '/exercise/deleteExerciseGuideBySeqExercise';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    updateExerciseBySeqExercise(data) {
        return new Promise((resolve, reject) => {
            const url = _API + '/exercise/updateClinicAssignedExercise';
            const conf = {
                headers: _HEADER()
            };

            let exerciseGuideTime = data?.exerciseGuide?.exerciseGuideTime;
            let date = new Date(null);
            date.setSeconds(exerciseGuideTime);
            let result = date.toISOString().substr(11, 8);

            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, {
                ...data,
                exerciseGuide: {
                    ...data.exerciseGuide,
                    exerciseGuideTime: result,
                }
            }, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    /**
     *
     * @param data
     * @returns {Promise<(ResDetailExerciseListBySeqMedicalRelationBySingleRangeJson, string)>}
     */
    getDetailExerciseListBySeqMedicalRelationBySingleRange(data) {
        return new Promise((resolve, reject) => {
            const url = _API + '/exercise/getDetailExerciseListBySeqMedicalRelationBySingleRange/v2';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}